import React, {useState} from 'react';
import { MapContainer, TileLayer, GeoJSON, LayersControl, useMapEvents} from 'react-leaflet'
import VVPuramHexagon from "../../data/basemaps/VVPuramHexagon.json";
import FoodStreet from "../../data/basemaps/FoodStreet.json";
import VVPuramHexagonResolution10 from '../../data/basemaps/VVPuramHexagonResolution10'
import VVPuramHexagonResolution11 from '../../data/basemaps/VVPuramHexagonResolution11'
import VVPuramHexagonResolution12 from '../../data/basemaps/VVPuramHexagonResolution12'
import VVPuramHexagonResolution13 from '../../data/basemaps/VVPuramHexagonResolution13'
import {h3IndexToSplitLong, latLngToCell} from 'h3-js';
import {getLocnIdfromCell, getLocnIdfromH3Id} from "../../locn/locn-utility";
import geojson2h3 from 'geojson2h3';

function LocnVVPuram() {
  const minResolutionLevel = 13;
  const [lat, setLat] = useState(12.951669636148447);
  const [long, setLong] = useState(77.5770474990684);
  const [zoomLevel, setZoomLevel] = useState(21);


  // For map generation
  const resolution = 15;
  const hexagons = geojson2h3.featureToH3Set(FoodStreet.features[0], resolution);
  const feature = geojson2h3.h3SetToMultiPolygonFeature(hexagons);
  console.log('geoJSON' + resolution);
  console.log(feature);

  // let getLatLongFromClick = (e) => {
  //   alert("Lat, Lon : " + e.latlng.lat + ", " + e.latlng.lng)
  // }

  let getCellFromClick = (e, resolution) => {
    const lat = e.latlng.lat;
    const long = e.latlng.lng;
    console.log(lat, long, resolution);
    const cell = latLngToCell(lat, long, resolution);
    return cell;
  }

  let onHexClick = (e, resolution) => {
    // console.log(e.target);
    // e.target.setStyle({
    //   fillColor : selectedColor,
    // });
    // console.log("onHexClick - Set color from state is : " + selectedColor);
    const h3CellId = getCellFromClick(e, resolution);
    console.log('h3CellId');
    console.log(h3CellId);
    let popup = e.target.getPopup();
    // console.log(popup);
    const lat = e.latlng.lat;
    const long = e.latlng.lng;
    popup.setContent(`
    <div>
      <div>lat - ${lat}</div>
      <div>long - ${long}</div>
      <div>h3cellId - ${h3CellId}</div>
      <div><h4>locn Id : ${getLocnIdfromH3Id(h3CellId)}</h4></div>
      <div><a target="_blank" href="https://maps.google.com/?q=${lat},${long}">Google Maps</div>
    </div>`
    );
  }

  //<div>h3cellId - ${h3CellId}</div>
  // <div>lat - ${lat}</div>
  // <div>long - ${long}</div>

  // let onWardMouseOver = (e) => {
  //   return;
  //   e.target.setStyle({
  //     fillColor : '#0000FF',
  //   });
  // }

  // const changeColor = (e) => {
  //   console.log("Color from state is : " + selectedColor);
  //   console.log("Changing the color to : " + e.target.value);
  //   setSelectedColor(e.target.value); 
  // }

  const onLeafletClickClosure = (resolution) => {
    return function onLeafletClick(e) {
      console.log('Clicked with resolution ' + resolution);
      onHexClick(e, resolution);
    };
  }

  const onEachHex = (feature, layer, resolution) => {
    // console.log(JSON.stringify(w.properties));
    // console.log(layer);
    // console.log(feature);
    layer.bindPopup('The resolution of this layer is ' + ' - ' + resolution);
    layer.on({
      click : onLeafletClickClosure(resolution),
      // mouseover : onWardMouseOver,
    });
  }

  const showLayer = (layerResolution) => {
    if (getH3ResolutionFromLeafletZoom(zoomLevel) === layerResolution) {
      return true
    }else{
      return false;
    }
  }

  const getH3ResolutionFromLeafletZoom = (leafletZoom) => {
    let resolution;
    if (zoomLevel < 18) {
      resolution = 10;
    }else if (zoomLevel >= 18 && zoomLevel <= 19 ) {
      resolution = 11;
    }else if (zoomLevel > 19 && zoomLevel <= 20 ) {
      resolution = 12;
    }else if (zoomLevel > 20) {
      resolution = 13;
    }
    return resolution;
  }

  const ZOOM_TO_H3_RES_MAPPING = {
    5: 1,
    6: 2,
    7: 3,
    8: 3,
    9: 4,
    10: 5,
    11: 6,
    12: 6,
    13: 7,
    14: 8,
    15: 9,
    16: 9,
    17: 10,
    18: 10,
    19: 11,
    20: 11,
    21: 12,
    22: 13,
    23: 14,
    24: 15,
};




  const ZoomLevelChanged = () => {
  const mapEvents = useMapEvents({
    zoomend: () => {
        console.log('Zoom End');
        console.log(mapEvents.getZoom());
        setZoomLevel(mapEvents.getZoom());
    },
  });
  return null
}

  // Reference - https://leafletjs.com/examples/choropleth/
  return (
    <>
    {console.log('Rendering with zoome level - ' + zoomLevel + ' resolution - ' + getH3ResolutionFromLeafletZoom(zoomLevel))}
    <MapContainer center={[lat, long]} zoomSnap={0.25} zoom={zoomLevel} maxZoom={30} scrollWheelZoom={true} >
      <ZoomLevelChanged/>
      {/* <Search provider={new OpenStreetMapProvider()} /> */}
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
        opacity='0.9'
        maxNativeZoom={19}
        minZoom={0}
        maxZoom={30}
      />
      <LayersControl position="topright">
        <LayersControl.Overlay checked={true} name="Bangalore">
            <GeoJSON data={VVPuramHexagon.features} style={{fillColor: 'red', color: 'black'}}/>
        </LayersControl.Overlay>        
        <LayersControl.Overlay checked={showLayer(10)} name="Resolution10">
            <GeoJSON data={VVPuramHexagonResolution10.features} style={{fillColor: 'yellow', color: 'black'}} onEachFeature={(f,l) => onEachHex(f,l, 10)} />
        </LayersControl.Overlay>        
        <LayersControl.Overlay checked={showLayer(11)} name="Resolution11">
            <GeoJSON data={VVPuramHexagonResolution11.features} style={{fillColor: 'blue', color: 'black'}} onEachFeature={(f,l) => onEachHex(f,l, 11)} />
        </LayersControl.Overlay>
        <LayersControl.Overlay checked={showLayer(12)} name="Resolution12">
            <GeoJSON data={VVPuramHexagonResolution12.features} style={{fillColor: 'green', color: 'black'}} onEachFeature={(f,l) => onEachHex(f,l, 12)} />
        </LayersControl.Overlay>
        <LayersControl.Overlay checked={showLayer(13)} name="Resolution13">
            <GeoJSON data={VVPuramHexagonResolution13.features} style={{fillColor: 'red', color: 'black'}} onEachFeature={(f,l) => onEachHex(f,l, 13)} />
        </LayersControl.Overlay>        
            {/* <GeoJSON style = {wardStyle()} data={WardBoundaries.features} onEachFeature={(f,l) => onEachWard(f,l)}/> */}
            {/* Uncomment <GeoJSON data={WardBoundaries.features} onEachFeature={(f,l) => onEachWard(f,l)}/> */}
            
            {/* <Marker position={[12.9052, 77.5629]}>
                <Popup>
                A pretty CSS3 popup. <br /> Easily customizable.
                </Popup>
            </Marker> */}
      </LayersControl>
    </MapContainer>
    {/* <input type = "color" value = {selectedColor} onChange = {changeColor} /> */}
    </>
  );
}

export default LocnVVPuram;